<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Produtos">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openBatchModal()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Produto</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
        

          <b-row>

            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany()"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            
            </b-col>
            
           
            <b-col cols="auto" >
              <b-form-group>
                  <label for="productType" style="font-size: 0.8em">Tipo de Produto</label>
                  <b-form-select id="productType"
                    v-model="filters.type"
                    :plain="true"
                    :options="selectProductTypeDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
          
            <b-col cols="auto" >
              <b-form-group>
                  <label for="filter" style="font-size: 0.8em">Localizar</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Localizar"></b-form-input>
              </b-form-group>
            </b-col>
          
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage" style="font-size: 0.8em">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <div class="d-flex align-items-center">
                <span class="text-muted">
                  <strong>Total:</strong> {{ items.length }} produtos
                  <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
                </span>
                <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
                <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
              </div>
            </b-col>
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
                selected-variant="primary"
                >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                           <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                           
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                


                <template #row-details="row">
                 
                  <table>
                        <tr width='100%'>
                          <td><i>Apelido: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.alias }}</b></td>
                          <td><i>Departamento: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.department }}</b></td>
                          <td><i>Cargo: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.jobname }}</b></td>
                          <td><i>Nascimento: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.daten }}</b></td>
                          <td width='100%'></td>
                        </tr>
                      </table>
                </template>
                
                <template v-slot:cell(avatar)="data">
                    <img :src="data.item.avatar ? data.item.avatar : 'img/noimage.png'" class="circle-img rounded-circle" />
                </template>
                
                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(name)="data">
                    <span class="text-brand-500">{{ data.item.ean }}</span><br>
                    <span class="text-dark font-weight-bold">{{ data.item.name }}</span><br>
                    <span class="text-primary">{{ data.item.description }}<br></span>
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>


        </b-card-body>
     </b-card>
  
     <b-modal title="Alterar Selecionados" class="modal-danger" v-model="dangerModal" @ok="changeStatusBatch" ok-variant="success"
        header-bg-variant="success"
        cancel-title="Cancelar"
     
     >
      Deseja realmente alterar o status dos usuários selecionados?
    </b-modal>
  
    <!--

      header-bg-variant="primary"
          
    -->
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Produto"
              size="lg">

              <b-nav fill>
            <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Dados do Produto</b-nav-item>
            <b-nav-item :active="tabInfo=='C'" @click="tabInfo='C'">Categorias</b-nav-item>
            <b-nav-item :active="tabInfo=='B'" @click="tabInfo='B'">Lotes</b-nav-item>
            <b-nav-item :active="tabInfo=='F'" @click="tabInfo='F'">Arquivos</b-nav-item>
            <b-nav-item :active="tabInfo=='K'" @click="tabInfo='K'">Kit</b-nav-item>
            <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico de Preço</b-nav-item>
          </b-nav>

          <div v-show="tabInfo=='F'">
            <b-card>
              <product-file-component></product-file-component>
            </b-card>
          </div>

          <div v-show="tabInfo=='K'">
            <b-card>
              <product-kit-component></product-kit-component>
            </b-card>
          </div>

          <div v-show="tabInfo=='H'">
            <b-card>
              <product-history-component></product-history-component>
            </b-card>
          </div>

          <div v-show="tabInfo=='C'">
            <b-card>
              <product-category-component :selectedProduct="selectedItem"></product-category-component>
            </b-card>
          </div>

          <div v-show="tabInfo=='B'">
            <b-card>
              <product-batch-component></product-batch-component>
            </b-card>
          </div>


          <div v-show="tabInfo=='P'">
            <b-card>

              <b-form @submit.stop.prevent="onSubmit">
              <div class="animated fadeIn">

                  
                  <b-form-group
                    description=""
                    label="Id"
                    label-for="id"
                    :label-cols="3"
                    :horizontal="true" v-show="selectedItem.id">
                    <b-form-input  v-model="selectedItem.id" id="id" type="text" autocomplete="id" placeholder="Id" readonly></b-form-input>
                  </b-form-group>    

                      
                  <b-form-group
                    description=""
                    label="Código"
                    label-for="code"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input  v-model="selectedItem.code" id="code" type="text" placeholder="Código"></b-form-input>
                  </b-form-group>    

                  <b-form-group
                    description=""
                    label="EAN"
                    label-for="ean"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input  v-model="selectedItem.ean" id="ean" type="text" placeholder="EAN"></b-form-input>
                  </b-form-group>    


                  <b-form-group
                    description=""
                    label="Produto"
                    label-for="name"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="selectedItem.name" id="name" type="text" autocomplete="name" placeholder="Produto"></b-form-input>
                  </b-form-group>

                  <b-form-group
                    description=""
                    label="Descrição"
                    label-for="description"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-textarea
                      id="textarea"
                      v-model="selectedItem.description"
                      placeholder=""
                      rows="3"
                    ></b-form-textarea>
                  </b-form-group>          


              
                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                </b-input-group>
              
             
              </div>
              </b-form>
            
                <div slot="footer" class="text-right">
                  <!--
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-toggle-on"></i><span>Habilitar</span></b-button>
                  <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-toggle-on"></i><span>Desabilitar</span></b-button>
                  -->
                  <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Produto</span></b-button>
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-window-close"></i><span>Fechar</span></b-button>

                </div>

            </b-card>
          </div>

  
  
      </b-modal>
  
    </div>
  
  </template>
  
<script>

import ProductCategoryComponent from './ProductCategoryComponent'
import ProductBatchComponent from './ProductBatchComponent'
import ProductFileComponent from './ProductFileComponent'
import ProductHistoryComponent from './ProductHistoryComponent'
import ProductKitComponent from './ProductKitComponent'

import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'
import MaskedInput from 'vue-text-mask'

import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, code: '', ean: '', name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      VueQuillEditor,
      ProductCategoryComponent,
      ProductBatchComponent,
      ProductFileComponent,
      ProductHistoryComponent,
      ProductKitComponent
    },
    data: () => {
      return {
        companyDDL: [],
        
        tabInfo: 'P',
        editorMessageOptions: {
              placeholder: 'Entre com sua mensagem',
              readonly: false,
              height: 250
            },
        isBusy: false,
        isLoadingMore: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },

        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        dangerModal: false,
        filters: {
          companyId: 0,
          key: '',
          status: 'A',
          type: 0
        },

        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
        currentItem: null,
        selectedItem: newItem,
        items: [          
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        productTypeDDL: [
        /*
        {
          text: 'Selecione um departamento',
          value: null,
          disabled: true
        }
        */ 
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "50px" }, tdClass: 'align-middle' },
          {key: 'avatar', label: "", thStyle: { width: "60px" }, tdClass: 'align-middle' },
          {key: 'id', label: 'Código', sortable: true, thStyle: { width: "15px" }, tdClass: 'text-center align-middle' },
          //{key: 'ean', label: 'EAN', sortable: true, tdClass: 'align-middle' },
          {key: 'typeName', label: 'Tipo de Produto', sortable: true, tdClass: 'align-middle', thStyle: { width: "150px" } },
          {key: 'name', label: 'Produto', sortable: true, tdClass: 'align-middle' },
          {key: 'umName', label: 'U/M', sortable: true, thStyle: { width: "40px" }, tdClass: 'text-center align-middle' },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" }, tdClass: 'text-center align-middle' }
        ],
        filterable: ['name'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.filteredItems.length },

      selectProductTypeDDL: function() {
        var list = [...this.productTypeDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },
      
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (
                 this.$utils.filterString(item.name, this.filters.key)
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                  && (this.filters.type==0 || item.typeId == this.filters.type )
              )
            })
        }
        catch(e) {
            console.log(e)
            return this.items;
        }
      }
    },
    watch: {
      filteredItems() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      perPage() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      }
    },
    methods: {

      changeStatusBatch() {
        this.selected.forEach(el => this.changeStatus(el))
        this.dangerModal = false
        this.refreshData()
        
      },
      openBatchModal: function() {

        if(this.selected.length > 0) {
          this.dangerModal = true
        }
        else {
          toast ({
              type: VueNotifications.types.error,
              title: 'Alterar Usuários',
              message: 'Nenhum usuário selecionado',
              timeout: 5000
            })
        }

        
      }, 
      submit() {
      },
      
      changeStatusClick(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';

          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var isNewProduct = !currentItem.id;
        var postData = {...currentItem};

        postData["companyId"] = this.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/product",
            postData
        ).then(function(resp) {
            // Mantém a janela aberta tanto ao incluir quanto ao alterar, para
            // permitir vincular Categorias/Lotes/Arquivos/Kit sem perder o contexto.
            if(isNewProduct && resp.data.obj) {
              s.selectedItem.id = resp.data.obj
            }

            toast ({
              type: VueNotifications.types.success,
              title: 'Produto',
              message: isNewProduct ? 'Produto criado. Inclua categorias, lotes e demais informações.' : 'Produto alterado com sucesso.',
              timeout: 5000
            })

            s.refreshData();
          }
        ).catch(function (error) {
          console.log(error);

          toast ({
            type: VueNotifications.types.warn,
            title: 'Produto',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })

        });

      },

      save() {

        let msgError = [];

        if(this.selectedItem.code.length <= 1)
          msgError.push("Código");
        if(this.selectedItem.name.length <= 3)
          msgError.push("Produto");

        if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
            type: VueNotifications.types.error,
            title: 'Produto',
            message: msgErrorExt,
            timeout: 5000
          })
        }
        else {
          this.saveItem(this.selectedItem);
        }

      },
      enableDisable() {
        //console.log('Habilitando/desabilitando usuário')
        this.changeStatus(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.tabInfo = 'P'
        if(item == null) {
            this.selectedItem = { ...newItem };
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }

        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },

      rowClicked(item) {
        this.currentItem = item
        //  //console.log(item);
            
        if(!this.tableSelectable) {
            this.clearSelectedRows();
           
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      async getProductType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.productTypeDDL = resp.data.obj
          }).catch(function(error) {
            console.log(error)
          })
      },
      filterChanged() {
          //if(this.filters.key && this.filters.key.length >= 4)
            this.refreshData();
        },
      async refreshData() {
          this.isBusy = true;
          this.isLoadingMore = false;

          var s = this;
          var currentUser = this.$store.state.currentUser;
          var page = 1;
          var pageSize = 100;
          var allItems = [];
          var hasMoreData = true;

          while (hasMoreData) {
            var url = this.$store.state.ws_url + "/product?companyId=" + s.filters.companyId + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
            try {
              var resp = await axios.get(url);

              if (resp.data.obj && resp.data.obj.length > 0) {
                allItems = allItems.concat(resp.data.obj);

                // Atualiza a tabela com os dados carregados até o momento
                s.items = [...allItems];

                // Remove o loading após carregar a primeira página
                if (page === 1) {
                  s.isBusy = false;
                  // Se há mais páginas, mostra o spinner de loading adicional
                  if (resp.data.obj.length === pageSize) {
                    s.isLoadingMore = true;
                  }
                }

                // Se retornou menos itens que o pageSize, não há mais páginas
                if (resp.data.obj.length < pageSize) {
                  hasMoreData = false;
                } else {
                  page++;
                }
              } else {
                // Sem mais dados
                hasMoreData = false;
              }
            } catch (error) {
              hasMoreData = false;
              toast({
                type: VueNotifications.types.error,
                title: 'Produto',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
              });
            }
          }

          this.isBusy = false;
          this.isLoadingMore = false;
      },

      changeCompany() {
        this.items = []
        this.getProductType()
        this.refreshData()
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId  

      this.changeCompany()
      
    }
  }
  </script>
  
<style scoped>

table#table-transition-example .flip-list-move {
  transition: transform 1s;
}

.circle-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  overflow: hidden;   
}

.ql-editor{
    min-height:200px;
}
</style>